import React from "react";
import ArrowHoverSvg from "../images/arrow-hover.svg";
import { motion } from "framer-motion";
import { Link } from "gatsby";
import {
  FADE_RIGHT,
  FADE_LEFT,
  SCALE_RIGHT,
} from "../components/animationUtils";
import PrismicLink from "../components/prismicLink";
import ArrowSvg from "./arrowSvg";
import { RichText } from "../utils/richText";

function PageTitle({ title, showLink, link, linkText, to, cls, body, ctaLabel, ctaUrl, ctaTarget }) {
  return (
    <motion.div
      className={`page-intro ${cls ? cls : ""}`}
      variants={{
        start: { transition: { staggerChildren: 0.3 } },
      }}
      animate={"start"}
    >
      <div className="page-intro__box">
        <motion.span
          {...SCALE_RIGHT}
          className="page-intro__line"
        ></motion.span>
        {showLink && (
          <motion.div {...FADE_LEFT}>
            {link?.url ? (
              <PrismicLink link={link}>
                <ArrowHoverSvg /> {linkText || "all work"}
              </PrismicLink>
            ) : (
              <Link to={to || "/work"}>
                <ArrowHoverSvg /> {linkText || "all work"}
              </Link>
            )}
          </motion.div>
        )}
      </div>
      <div className="page-intro__content">
        {title && (
          <motion.h1 {...FADE_RIGHT} className="page-intro__title">
            {title}
          </motion.h1>
        )}
        {body && (
          <motion.div {...FADE_RIGHT} className="page-intro__body">
            {RichText(body)}
          </motion.div>
        )}
        {ctaLabel && ctaUrl && (
          <motion.div {...FADE_RIGHT} className="page-intro__cta">
            <a href={ctaUrl} target={ctaTarget}>
              {ctaLabel}
              <ArrowSvg />
            </a>
          </motion.div>
        )}
      </div>
    </motion.div>
  );
}

export default PageTitle;
